import { ApiRoutingUtils } from '@/Routing';
import { rest } from '@/Api/Rest';
import { GetGroupedUserWarehouseResponse } from './Responses/GetGroupedUserWarehouseResponse';
import { UpdateLogisticContractStateRequest } from './Requests/UpdateLogisticContractStateRequest';
import { UpdateLogisticContractStateResponse } from './Responses/UpdateLogisticContractStateResponse';
import { GetLogisticContractResponse } from './Responses/GetLogisticContractResponse';
import { DeleteLogisticContractRequest } from './Requests/DeleteLogisticContractRequest';
import { GetOrderLogisticContractResponse } from './Responses/GetOrderLogisticContractResponse';
import { GetOrderLogisticContractRequest } from './Requests/GetOrderLogisticContractRequest';
import { GetAllLogisticContractResponse } from './Responses/GetAllLogisticContractResponse';
import { CreateLogisticContractRequest } from './Requests/CreateLogisticContractRequest';
import { CreateLogisticContractResponse } from './Responses/CreateLogisticContractResponse';
import { UpdateLogisticContractRequest } from './Requests/UpdateLogisticContractRequest';
import { UpdateLogisticContractResponse } from './Responses/UpdateLogisticContractResponse';
import { CheckLogisticContractRequest } from './Requests/CheckLogisticContractRequest';
import { CheckLogisticContractResponse } from './Responses/CheckLogisticContractResponse';
import { GetOrdersWarehouseInfoRequest } from './Requests/GetOrdersWarehouseInfoRequest';
import { GetOrdersWarehouseInfoResponse } from './Responses/GetOrdersWarehouseInfoResponse';
import { GetLogisticLabelFormatsRequest } from '@/Api/LogisticContracts/Requests/GetLogisticLabelFormatsRequest';
import { GetLogisticLabelFormatsResponse } from '@/Api/LogisticContracts/Responses/GetLogisticLabelFormatsResponse';

const url = ApiRoutingUtils.createUrl('logistic-contracts');
const warehouseUrl = ApiRoutingUtils.createUrl('user-warehouse-logistic-contracts');

async function getAllLogisticContracts(): Promise<GetAllLogisticContractResponse> {
  return rest.get(`${url}`);
}

async function getLogisticContract(id: number): Promise<GetLogisticContractResponse> {
  return rest.get(`${url}/${id}`);
}

async function createLogisticContract(request: CreateLogisticContractRequest): Promise<CreateLogisticContractResponse> {
  return rest.post(url, request);
}

async function updateLogisticContract(request: UpdateLogisticContractRequest): Promise<UpdateLogisticContractResponse> {
  return rest.put(url, request);
}

async function deleteLogisticContract(request: DeleteLogisticContractRequest): Promise<number> {
  return rest.delete(url, request);
}

async function checkConnection(request: CheckLogisticContractRequest): Promise<CheckLogisticContractResponse> {
  return rest.post(`${url}/check-connection`, request);
}

async function getOrderLogisticContract(
  request: GetOrderLogisticContractRequest,
): Promise<GetOrderLogisticContractResponse> {
  return rest.get(`${url}/active-by-type`, request);
}

async function getGroupedUserWarehouses(): Promise<GetGroupedUserWarehouseResponse> {
  return rest.get(`${warehouseUrl}/grouped-by-mandat-countries`);
}

async function updateLogisticContractState(
  request: UpdateLogisticContractStateRequest,
): Promise<UpdateLogisticContractStateResponse> {
  return rest.put(`${url}/update-state`, request);
}

async function getOrdersWarehouseInfo(request: GetOrdersWarehouseInfoRequest): Promise<GetOrdersWarehouseInfoResponse> {
  return rest.post(`${url}/orders-warehouse-info`, request);
}

async function getLogisticLabelFormats(
  request: GetLogisticLabelFormatsRequest,
): Promise<GetLogisticLabelFormatsResponse> {
  return rest.get(`${url}/label-formats`, request);
}

export const LogisticContractsApi = {
  getAllLogisticContracts,
  getLogisticContract,
  createLogisticContract,
  updateLogisticContract,
  deleteLogisticContract,
  checkConnection,
  getOrderLogisticContract,
  getOrdersWarehouseInfo,
  getGroupedUserWarehouses,
  updateLogisticContractState,
  getLogisticLabelFormats,
};
